import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  withStyles,
} from '@material-ui/core'

const styles = theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(1),
    justifyContent: 'space-between',

    '& > *': {
      marginRight: theme.spacing(1),

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
  center: {
    alignItems: 'center',
  },
  start: {
    alignItems: 'flex-start',
  },
  end: {
    alignItems: 'flex-end',
  },
})


const Inline = ({
  align,
  classes,
  children,
  className,
}) => (
  <div className={classNames(classes.root, classes[align], className)}>
    {children}
  </div>
)


Inline.defaultProps = {
  align: 'center',
}


Inline.propTypes = {
  align: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Inline)
